import {http} from './config';
export default {

    save: (pedido) => {
        return http.post('api/pedidos', pedido, { timeout: 30000, skipAuthInterceptor: true });
    },

    listarPedidos: () => {
        return http.get('api/pedidos');
    },

    cambiarEstado: (id, estado) => {
        return http.put('api/pedidos/' + id + '/estado', { estado });
    },

    delete: (id) => {
        return http.delete('api/pedidos/' + id);
    }
}
